<template>
    <div class="animated fadeIn container page-content">
        <b-tabs
            pills
            card
            content-class="tab-content-custom"
            active-nav-item-class="font-weight-bold text-uppercase text-white"
        >
            <b-tab title="Tin cảnh báo" active>
                <ul class="list-unstyled">
                    <b-media
                        tag="li"
                        v-for="(item, index) in listWarningNewsDisplay"
                        :key="index"
                        class="cursor-pointer"
                        @click="getInfo(item.id)"
                    >
                        <template #aside>
                            <b-img
                                :src="
                                    item.avatar
                                        ? `${API_CONFIG.URL_GET_FILE}${item.avatar}`
                                        : '/img/image_news.jpeg'
                                "
                                width="64"
                                height="64"
                                alt="Ảnh"
                            />
                        </template>
                        <h5
                            class="mt-0 mb-1 text-primary news-title"
                            :style="isMobile ? '' : 'height: 40px'"
                        >
                            {{ item.name }}
                        </h5>
                        <p class="text-muted">{{ item.date | formatDate }}</p>
                    </b-media>
                </ul>
                <b-pagination
                    align="center"
                    v-if="listWarningNewsDisplay.length > 10"
                    v-model="currentPageNormal"
                    :total-rows="listWarningNewsDisplay.length"
                    :per-page="10"
                />
            </b-tab>
            <b-tab title="Tin thường">
                <ul class="list-unstyled">
                    <b-media
                        tag="li"
                        v-for="(item, index) in listNormalNewsDisplay"
                        :key="index"
                        class="cursor-pointer"
                        @click="getInfo(item.id)"
                    >
                        <template #aside>
                            <b-img
                                :src="
                                    item.avatar
                                        ? `${API_CONFIG.URL_GET_FILE}${item.avatar}`
                                        : '/img/image_news.jpeg'
                                "
                                width="64"
                                height="64"
                                alt="Ảnh"
                            />
                        </template>
                        <h5
                            class="mt-0 mb-1 text-primary news-title"
                            :style="isMobile ? '' : 'height: 40px'"
                        >
                            {{ item.name }}
                        </h5>
                        <p class="text-muted">{{ item.date | formatDate }}</p>
                    </b-media>
                </ul>
                <b-pagination
                    align="center"
                    v-if="listNormalNewsDisplay.length > 10"
                    v-model="currentPageWarning"
                    :total-rows="listNormalNewsDisplay.length"
                    :per-page="10"
                />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import API_CONFIG from '@/api-config';
export default {
    data() {
        return {
            API_CONFIG,
            currentPageNormal: 1,
            currentPageWarning: 1
        };
    },
    computed: {
        ...mapState({
            listNews: (state) => state.news.items,
            isMobile: (state) => state.page.isMobile
        }),
        listWarningNewsDisplay() {
            let listData = this.listNews.filter(
                (item) => item.status == 'PUBLISH' && item.type == 'WARNING'
            );
            return listData.sort((a, b) => this.compareDate(a, b));
        },
        listNormalNewsDisplay() {
            let listData = this.listNews.filter(
                (item) => item.status == 'PUBLISH' && item.type == 'NORMAL'
            );
            return listData.sort((a, b) => this.compareDate(a, b));
        }
    },
    methods: {
        ...mapActions({
            getList: 'news/getList'
        }),
        getInfo(newsId) {
            this.$router.push(`/news/${newsId}`);
        },
        compareDate(a, b) {
            if (this.$moment(a.date).isAfter(this.$moment(b.date))) return -1;
            if (this.$moment(a.date).isBefore(this.$moment(b.date))) return 1;
            return 0;
        }
    },
    created() {
        this.getList();
    }
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1025px) {
    .page-content {
        padding: 0px 120px;
    }
}
@media screen and (max-width: 500px) {
    .page-content {
        padding: 0px;
        .fit-page-row {
            margin: 0px !important;
            .fit-page-col {
                padding: 0px !important;
            }
        }
    }
}
.news-title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>
